export default __webpack_public_path__ + "static/media/PlayIcon.e608657b.svg";